import type { AgencyAccount, CustomerTravelSeller } from '@eti/schema-types';
import type { CountryType } from '../../../common/utils/models';
import { AGENCY_FORM_SECTION, agencyFields } from '../constants/formFields';
import type { Country, FormData } from '../models';
import { getCountryIdFromPrefix } from './contactInformation';

export const getInitialValuesForAgencyForm = (
  agencyAccount: AgencyAccount | null,
  defaultCountry: CountryType,
  countries: Country[],
  customerData?: CustomerTravelSeller | null,
) => {
  const countryId = getCountryIdFromPrefix(countries, customerData?.phone?.countryCallingCode);

  return agencyAccount
    ? {
        [AGENCY_FORM_SECTION]: {
          [agencyFields.NAME]: agencyAccount.name,
          [agencyFields.OFFICE_ID]: agencyAccount.code,
          [agencyFields.AGENT_FIRST_NAME]: customerData?.firstName,
          [agencyFields.AGENT_LAST_NAME]: customerData?.lastName,
          [agencyFields.AGENT_EMAIL]: customerData?.email,
          [agencyFields.AGENT_PHONE]: customerData?.phone?.numberWithoutCountryCode,
          [agencyFields.AGENT_PHONE_COUNTRY_ID]: countryId ?? defaultCountry?.id,
        },
      }
    : {};
};

export const transformAgentInformationFormData = (formValues: FormData, countries: Country[]) => {
  const agentInfo = formValues[AGENCY_FORM_SECTION];

  if (!agentInfo) {
    return undefined;
  }

  const country = countries.find((c) => c.id === agentInfo[agencyFields.AGENT_PHONE_COUNTRY_ID]);

  return {
    firstName: agentInfo[agencyFields.AGENT_FIRST_NAME],
    lastName: agentInfo[agencyFields.AGENT_LAST_NAME],
    contactInformation: {
      email: agentInfo[agencyFields.AGENT_EMAIL],
      cellPhone: {
        prefixId: country?.phoneCountryId,
        phoneNumberAfterPrefix: agentInfo[agencyFields.AGENT_PHONE],
        countryId: country?.id,
      },
    },
  };
};
